import React, { useEffect, useState } from "react";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Button, message, Card, Input, Row, Col, Tooltip, Divider } from "antd"
import { CopyOutlined } from '@ant-design/icons';
import { useParams, useNavigate } from 'react-router-dom';
import blacklogo from "../../assests/images/collab_ai_logo_black.svg";
import whitelogo from "../../assests/images/collab_ai_logo_white.svg"
import "./customcodestyle.css"
import { generateCustomEmbedCode } from "../../constants/Api_constants";

const CustomizeEmbedCode = () => {
  const { assistantId, assistantName } = useParams();
  const [bgColor, setBgColor] = useState('#ffffff');
  const [textColor, setTextColor] = useState('#000000');
  const [themeColor, setThemeColor] = useState('#0F91F2');
  const [isDarkTheme, setIsDarkTheme] = useState(false);
  const navigate = useNavigate();
  const baseURL = process.env.REACT_APP_FE_URL;
  const embedCode = generateCustomEmbedCode(assistantId, bgColor, textColor, themeColor, baseURL);

  const navigateHome = () => {
    navigate('/');
  };

  useEffect(() => {
    const theme = localStorage.getItem('theme');
    if (theme === 'dark') {
      setIsDarkTheme(true);
    } else {
      setIsDarkTheme(false);
    }
  }, []);

  return (
    <div className="embedded-container">
      <Card className="embedded-card" hoverable>
        <img
          src={isDarkTheme ? whitelogo : blacklogo}
          alt="Logo"
          className="logo"
          onClick={navigateHome}
        />

        <h2 className="title">Customize Your Embed Code</h2>

        <Row gutter={[16, 16]}>
          <Col xs={24} sm={8}>
            <Card title="Background Color" hoverable className="color-card">
              <Tooltip title="Choose the background color for the chatbot">
                <div className="color-selector">
                  <div
                    className="color-circle"
                    style={{ backgroundColor: bgColor }}
                  />
                  <Input
                    type="color"
                    value={bgColor}
                    onChange={(e) => setBgColor(e.target.value)}
                    className="color-input"
                  />
                </div>
              </Tooltip>
            </Card>
          </Col>
          <Col xs={24} sm={8}>
            <Card title="Text Color" hoverable className="color-card">
              <Tooltip title="Choose the text color for the chatbot">
                <div className="color-selector">
                  <div
                    className="color-circle"
                    style={{ backgroundColor: textColor }}
                  />
                  <Input
                    type="color"
                    value={textColor}
                    onChange={(e) => setTextColor(e.target.value)}
                    className="color-input"
                  />
                </div>
              </Tooltip>
            </Card>
          </Col>
          <Col xs={24} sm={8}>
            <Card title="Theme Color" hoverable className="color-card">
              <Tooltip title="Choose the theme color for the chatbot">
                <div className="color-selector">
                  <div
                    className="color-circle"
                    style={{ backgroundColor: themeColor }}
                  />
                  <Input
                    type="color"
                    value={themeColor}
                    onChange={(e) => setThemeColor(e.target.value)}
                    className="color-input"
                  />
                </div>
              </Tooltip>
            </Card>
          </Col>
        </Row>

        <div className="embed-code">
          <label className="embed-label">Embed Code:</label>
          <textarea
            value={embedCode}
            readOnly
            rows="4"
            className="embed-textarea"
          />
        </div>

        <CopyToClipboard
          text={embedCode}
          onCopy={() => message.success('Custom embed code copied to clipboard')}
        >
          <Button
            type="primary"
            icon={<CopyOutlined />}
            className="copy-button"
          >
            Copy Embed Code
          </Button>
        </CopyToClipboard>
      </Card>
    </div>
  );
};

export default CustomizeEmbedCode;